import type { FC } from "react";
import { Header } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/tableTop/Header";
import styled from "styled-components";
import type {
    IFilters } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/types";


import { GenderFilter } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/tableTop/Filters/GenderFilter";
import { AgeFilter } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/tableTop/Filters/AgeFilter";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const FiltersContainer = styled(FlexRow)`
    padding: 12px 24px;
    gap: 8px;
`;

interface ITableTop {
    filters: IFilters;
    setFilters: (filters: IFilters) => void;
    totalCount: number;
}

export const TableTop: FC<ITableTop> = (props) => {
    const { filters, setFilters, totalCount } = props;
    const { genderID, ageBucketIDs } = filters;
    const setGenderID = (genderID) => {
        setFilters({ ...filters, genderID });
    };
    const setAgeBucketIDs = (ageBucketIDs) => {
        setFilters({ ...filters, ageBucketIDs });
    };
    return (
        <div>
            <Header filters={filters} totalCount={totalCount} />
            <FiltersContainer>
                <GenderFilter
                    genderID={genderID}
                    setGenderID={setGenderID}
                    ageBucketIDs={ageBucketIDs}
                />
                <AgeFilter
                    ageBucketIDs={ageBucketIDs}
                    setAgeBucketIDs={setAgeBucketIDs}
                    genderID={genderID}
                />
            </FiltersContainer>
        </div>
    );
};
